<template>
    <div class="master-template-select-view-control multiselect-view-control">
        <ButtonGroup>
            <Button :class="{ active: view === MultiviewMode.Grid }" @click="switchView(MultiviewMode.Grid)">
                <Icon type="md-apps" />
            </Button>
            <Button :class="{ active: view === MultiviewMode.List }" @click="switchView(MultiviewMode.List)">
                <Icon type="md-list" />
            </Button>
        </ButtonGroup>
    </div>
</template>

<script lang="ts">
import { MultiviewMode } from "@/enums/multiview";
import { MasterTemplateLibraryAction } from "@/store/modules/masterTemplateLibrary";

export default {
    name: "MasterTemplateSelectViewControl",

    data() {
        return {
            MultiviewMode
        };
    },

    computed: {
        view() {
            return this.$store.state.masterTemplateLibrary.selectViewMode;
        }
    },

    methods: {
        switchView(view: (typeof MultiviewMode)[keyof typeof MultiviewMode]) {
            this.$store.dispatch(MasterTemplateLibraryAction.SetSelectViewMode, view);
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.multiselect-view-control {
    display: flex;
    flex-wrap: nowrap;

    .ivu-btn.active {
        z-index: 1;
    }
}

.master-template-select-view-control {
    margin-right: $spacing;
}
</style>
